import { useState, useEffect } from "react";
import "./AccessPage.css";
import {
  Login_url,
  SignUpUrl,
  ENV_URL,
} from "../../Essentials/variables";
import axios from "axios";
import _ from "lodash";
import useAccess from "../LoginPage/useAccess";
import adminLogo from "../../assets/admin_logo.png";
import mapLogo from "../../assets/map-logo.png";
import reportLogo from "../../assets/report_logo.png";
import CustomTile from "./CustomTile";
import CustomTilePopup from "./CustomTilePopup";
import CustomTile2 from "./CustomTile2";
import { getADFSLogoutUrl, getADFSTokenUrl } from "../../store/apis/authApi";
import jwtDecode from 'jwt-decode';

export default function AccessPage(props) {
  const [id, setId] = useState("null");
  const [mapAccess, setMapAccess] = useState(false);
  const [adminAccess, setAdminAccess] = useState(false);
  const [reportAccess, setReportAccess] = useState(false);
  const [message, setMessage] = useState(
    "_________Loading ADFS Response________"
  );
  const [requestButton, setRequestButton] = useState(false);
  const [accessname, setAccessname] = useState();
  const [accesstype, setAccesstype] = useState();
  const [employeename, setEmployeename] = useState();
  const [signupButton, setSignupButton] = useState(false);
  const { removeAccess } = useAccess();
  // const [updateDealer,updateDealerResults]=useUpdateDealerMutation();
  const [showPopup, setShowPopup] = useState(false);
  const [user, setUser] = useState({ name: "", email: "" });

  const handleUpdate = (updatedUser) => {
    // Update the user details
    setUser(updatedUser);
  };
  function handleReportClick() {
    console.log("HIT ME REPORT");
    props.nav("/report");
  }

    const redirectToLogin = () => {
      localStorage.clear();
      props.nav('/');
    };

    const handleLogoutButton = async () => {
      removeAccess();
      const redirectUrl = await getADFSLogoutUrl();
      if (!redirectUrl) {
        throw new Error("Redirect URL not received");
      }
      // Required for ADFS / OAuth
      window.location.assign(redirectUrl);
      redirectToLogin();
    };
  

  /////////////////////////////////////Login codes////////////////////////////////
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    if(code){
      getADFSTokenUrl(code).then((res) => {
      setMessage("_________Loading Credentials________");
      const token = res.IdToken;
      const refreshToken = res.RefreshToken;
      const accessToken = res.AccessToken;
      if (!token) throw new Error("No token received in response");
      console.log("Not Decoded JWT:", token);

      const decoded = jwtDecode(token);
      const username = decoded["cognito:username"];
      const parts = username.split(/\\|ad-msil_|msil-common-ad_/).pop();
      const fullEmail = (decoded.email || "").toLowerCase();
      const Email = decoded.email.split("@")[0];
      // Scoped override: only these ADFS emails map to a fixed userid.
      // All other users continue using cognito username-derived `parts`.
      const OVERRIDE_EMAILS = [
        "happiest_umishra@maruti.co.in",
        "happiestminds_uditprasad.mishra@maruti.co.in",
      ];
      const userid = OVERRIDE_EMAILS.includes(fullEmail) ? "715752" : parts;
      const Token= token;
      console.log("token",Token);
      localStorage.setItem("IdToken",Token);
      localStorage.setItem("RefreshToken",refreshToken);
      localStorage.setItem("AccessToken",accessToken);
      localStorage.setItem("Email",Email);
      console.log("4", Email, "->", userid);
      setId(parts[1]);
      setEmployeename(Email);
      axios({
        method: "POST",
        data: {
          userid,
        },
        withCredentials: true,
        url: Login_url,
      }).then((results) => {
        console.log(results.data);
        //data: "Success Autheticated"
        if (results.data?.message === "Need to signup") {
          console.log("Condition 1");
          setAccessname(results.data?.data[0]?.access_name);
          setAccesstype(results.data?.data[0]?.access_type);
          setEmployeename(results.data?.data[0]?.employee_name);
          //  console.log(res.data?.data[0]?.access_name);
          //  console.log(res.data?.data[0]?.access_type)
          //  console.log(res.data?.data[0]?.employee_name);
          setMessage("Request for the website access");
          setRequestButton(true);
        } else if (results.data?.message === "user not found in table") {
          console.log("Condition 2");
          setMessage("You are not a part of this website");
          setSignupButton(true);
        } else if (results.data?.message === "user status is pending") {
          console.log("Condition 3");
          setMessage("Your Request is pending from admin.");
        } else if (results.data?.token) {
          if (results.data?.access === "Yes") {
            setMapAccess(true);
          }
          if (results.data?.admin === "Yes") {
            setAdminAccess(true);
          }
          if (results.data?.report === "Yes") {
            setReportAccess(true);
          }
          setMessage(`Hello, ${results.data.Name}`);
          // console.log("Saving....");
          localStorage.setItem("token", JSON.stringify(results.data["token"]));
          localStorage.setItem(
            "userInfo",
            JSON.stringify(_.omit(results.data, ["token"]))
          );
           props.nav('/gis')
        } else {
          setMessage("Some went wrong. Please try again.");
        }
      });
    });
    } else {
      const userDealerEmployee = JSON.parse(localStorage.getItem("userInfo"));
      
      const ExistingToken = localStorage.getItem('token')
      if( ExistingToken ){
        console.error("token found reusing token");
        const decoded = jwtDecode(ExistingToken);
        const tokenExpiryTime = decoded.exp;
        const isExpired = tokenExpiryTime * 1000 < Date.now();

        if (isExpired) {
          console.warn("Token expired. Redirecting to login.");
          redirectToLogin();
          return;
        } else {
          if (ExistingToken && !isExpired) {
            const EmailId = localStorage.getItem("Email");
            if (EmailId) {
              setEmployeename(EmailId);
            }
            setMessage(`Hello, ${userDealerEmployee?.Name}`);
            if (userDealerEmployee?.access === "Yes") {
              setMapAccess(true);
            }
            if (userDealerEmployee?.admin === "Yes") {
              setAdminAccess(true);
            }
            if (userDealerEmployee?.report === "Yes") {
              setReportAccess(true);
            }
          } else {
            setMessage(
              "_________Not able to authorize user redirecting to login page________"
            );
            redirectToLogin();
          }
        }
      }
    }
    
  }, []);
  ////////////////////////////END///////////////////////////////////////
  const handletestclick = () => {
    // axios({
    //   method:'POST',
    //   data:{
    //     userid:'294802',
    //   },
    //   withCredentials:false,
    //   url:'https://dev.msilruralmaps.com:9000/test'
    // })
  };
  //////////////////////////SIGNUP//////////////////////////////////////
  const handleSignupButton = () => {
    axios({
      method: "POST",
      data: {
        email: id,
        accessname: accessname,
        accesstype: accesstype,
        employeename: employeename,
        type: "employee",
      },
      withCredentials: false,
      url: SignUpUrl,
    }).then((res) => {
      console.log(res.data);
      //data: "Success Autheticated"
      if (res.data?.message === "success") {
        setMessage("Request sent successfully");
        setRequestButton(false);
      }
    });
  };
  const handleTileClick = () => {
    setShowPopup(true);
  };
  ////////////////////////End Signup/////////////////////
  const handleSignupUserButton = () => {
    axios({
      method: "POST",
      data: {
        email: id,
        accessname: accessname,
        accesstype: accesstype,
        employeename: employeename,
        type: "employee",
      },
      withCredentials: false,
      url: SignUpUrl,
    }).then((res) => {
      console.log(res.data);
      //data: "Success Autheticated"
      if (res.data?.message === "success") {
        setMessage("Request sent successfully");
        setSignupButton(false);
      }
    });
    
    // setShowPopup(true);
    // setSignupButton(false);
    // setMessage("Your Details has been sent.");
  };
  const handleClosePopup = () => {
    setShowPopup(false);
  };

  const [options, setOptions] = useState();

  const userDealerEmployee = JSON.parse(localStorage.getItem("userInfo"));
  return (
    <section
      style={{
        backgroundImage: " url(background.png)",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "fixed",
        height: "100vh",
        display: "flex",
        flexDirection: "column",  
      }}
    >
      <div className="accesspage-header-container ">
        <img src="marutilogo.png" className="h-[72px] w-auto max-w-[330px] object-contain" alt="Logo" />
        <button
          onClick={handleLogoutButton}
          style={{ backgroundColor: "#171cdf" }}
          className="text-white font-roboto py-1 px-4 rounded-[4px] ml-auto mr-3"
        >
          Logout
        </button>
        <img className="h-10 pb-3" src="powered-by-logo.png" alt="Logo" />
      </div>
      <div className=" welcome-message-container g-6 text-gray-800">
        <div className="">
          <h3 className="text-slate-200 font-mono underline px-56">
            {message}
          </h3>
        </div>
        <div className="text-center items-center pt-4">
          {requestButton && (
            <div className="px-56 pt-20">
              {/* <button onClick={handleSignupButton} type="button" className="text-white bg-gradient-to-br from-purple-600 to-blue-500 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-10 py-3 text-center mr-2 mb-2">Request Access</button> */}
              <button
                onClick={handleSignupButton}
                type="button"
                className="text-white bg-gradient-to-br from-purple-600 to-blue-500 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-10 py-3 text-center mr-2 mb-2"
              >
                Request Access
              </button>
            </div>
          )}
          {signupButton && (
            <div className="px-56 pt-20">
              <button
                onClick={handleSignupUserButton}
                type="button"
                className="text-white bg-gradient-to-br from-purple-600 to-blue-500 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-10 py-3 text-center mr-2 mb-2"
              >
                Sign Up
              </button>
            </div>
          )}
          {/* {showPopup && <UpdatePopup onClose={handleClosePopup} onUpdate={handleUpdate} profile={userData} requestfrom="user" id={id} />} */}
        </div>
      </div>
      <div className="main-tiles-container">
        {mapAccess && (
          <CustomTile
            nav={props.nav}
            tileLogo={mapLogo}
            title="Coverage & Potential"
            about="Click here to see maps"
            path="access"
          />
        )}
        {adminAccess && (
          <CustomTile
            nav={props.nav}
            tileLogo={adminLogo}
            title="Admin"
            about="Provide role based access"
            path="dealeradmin"
          />
        )}
        {/* {reportAccess && (
          <CustomTile
            nav={props.nav}
            tileLogo={reportLogo}
            title="User Logs"
            about="See the user logs"
            path="userLogs"
          />
        )} */}
        {/* {reportAccess && (
          <CustomTilePopup
            nav={props.nav}
            tileLogo={reportLogo}
            title="Reporting Layer"
            about="See the reporting level"
            path="summary"
          />
        )} */}
         {reportAccess  && <CustomTile2 tileLogo={reportLogo} title='Reporting Layer' about='See the reporting level' onClick={handleTileClick} />}
         {showPopup && (
              <CustomTilePopup onClose={handleClosePopup}>
                {/* Add two additional custom tiles inside the popup */}
                <CustomTile
                  nav={props.nav}
                  title="Reports & Download"
                  about="click here to download reports"
                  path='summary'
                  tileLogo={reportLogo}
                  

                />
                <CustomTile
                  nav={props.nav}
                  title="Log Dashboard"
                  about="Click here to see the logs"
                  path='userLog'
                  tileLogo={reportLogo}

                />
              </CustomTilePopup>
            )}
      </div>
    </section>
  );
}
